var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.727 17.26c.253.254.609.407.964.407s.685-.127.964-.407l6.342-6.356 6.342 6.356c.254.254.609.407.964.407s.685-.127.964-.407c.533-.534.533-1.399 0-1.907l-6.342-6.356 6.342-6.356c.533-.534.533-1.399 0-1.907a1.33 1.33 0 00-1.903 0L9.022 7.09 2.68.734a1.33 1.33 0 00-1.903 0c-.532.534-.532 1.398 0 1.907L7.12 8.997.777 15.353a1.296 1.296 0 00-.05 1.907z"}));
}

MenuClose.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
